
export const CONNECTING = "Connecting wallet";
export const CONNECTED = "Connected";
export const SELECTING_NET = "Select network";
export const NETWORK_SELECTED = "Network selected";
export const SELECTING_TOKEN = "Select token";
export const TOKEN_SELECTED = "Token selected";
export const CONVERTING_CURRENCY = "Converting currency";
export const CHECKING_BALANCE = "Checking balance";
export const INSUFFICIENT_BALANCE = "Insufficient balance";
export const SPEND_CHECK = "Checking allowance";
export const SPEND_SUFFICIENT = "Allowance sufficient";
export const SPEND_INSUFFICIENT = "Allowance insufficient";
export const SPEND_INCREASE = "Increasing allowance";
export const SIGNING_DEPOSIT = "Signing deposit";
export const SIGNING = "Signing payment";
export const SIGNED_DEPOSIT = "Signed deposit";
export const SIGNED = "Payment signed";
export const UPDATING_PAY_RECORD = "Updating payment";
export const RECORD_UPDATED = "Record updated";
export const ERROR = "Error";